// UPLOAD-BUNDLE-001 — Warum diese Datei `.mjs` ist und echtes ESM enthält.
//
// Sie hat DREI Konsumenten, die sie alle nativ laden können müssen:
//   1. das Admin-Bundle (webpack/CRA)        → `import` in AgentPanel.js
//   2. der Jest-Lauf des Admin (babel)       → marketDigestCore.test.js
//   3. der Node-Sicherheitstest des Backends → market-digest-weekly.test.js (PII-Filterung)
//
// Zwei Sackgassen, beide produktiv erlebt:
//   · `.cjs` — react-scripts 5 matcht Module über /\.(js|mjs|jsx|ts|tsx)$/. `.cjs` fällt dort
//     NICHT hinein und landet als statische Datei in `static/media/`. Der Import lieferte dann
//     die URL als Zeichenkette, der Aufruf warf `TypeError` → der Markt-Import war tot.
//   · `.js` mit `module.exports`, per `require()` aus einer ESM-Quelle geholt — webpack führt
//     das Modul im ESM-Kontext aus und bricht beim Init hart ab:
//     „ES Modules may not assign module.exports". Das legte den GESAMTEN Admin weiß.
//
// `.mjs` mit `export` löst beides: CRA bündelt es (Endung ist in der Regex), Node lädt es per
// `import()` nativ, Babel/Jest transformiert es. EINE Quelle der Wahrheit, kein Zweitpfad.
'use strict';

const ROW_FIELDS = Object.freeze([
  'region', 'dimension', 'bucket', 'n_trips', 'median_price', 'avg_price', 'p10_price',
  'p25_price', 'p75_price', 'p90_price',
  'median_km', 'median_eur_km', 'surge_spread', 'sort_order', 'completed_count',
  'rider_cancelled_count', 'driver_cancelled_count', 'failed_count', 'completion_rate',
  'rider_cancel_rate', 'driver_cancel_rate', 'min_price', 'max_price', 'avg_km', 'avg_eur_km',
  'median_duration', 'avg_duration', 'price_index', 'inferred_price_peak', 'confidence',
  'price_evidence_count', 'distance_evidence_count', 'eur_km_evidence_count',
  'duration_evidence_count',
]);

const COVERAGE_FIELDS = Object.freeze([
  'raw_rows', 'unique_activities', 'duplicates', 'completed', 'rider_cancelled',
  'driver_cancelled', 'failed', 'invalid', 'outside_week', 'price_covered',
  'distance_covered', 'eur_km_covered', 'duration_covered', 'source_count', 'generated_aggregates',
  'suppressed_small_cells', 'detected_cities', 'detected_postal_zones',
  'pickup_coordinate_covered', 'pickup_cell_version', 'pickup_cell_status',
  'detected_pickup_cells',
]);

function allowlisted(source, fields) {
  return Object.fromEntries(fields
    .filter((field) => Object.prototype.hasOwnProperty.call(source || {}, field))
    .map((field) => [field, source[field]]));
}

function projectMarketDigestAggregatePayload(candidate) {
  if (candidate && candidate.period_from && candidate.period_to
      && Array.isArray(candidate.slices) && candidate.slices.length) {
    const slices = candidate.slices.map((slice, index) => {
      const projected = projectMarketDigestAggregatePayload(slice);
      if (!projected || Array.isArray(projected.slices)) return null;
      return { ...projected, slice_index: index, slice_complete: slice.slice_complete === true };
    });
    if (slices.some((slice) => !slice)) return null;
    // MARKET-WEEK-0400-001: Die Wochendefinition MUSS die Allowlist ueberleben — ohne sie
    // kaeme im Backend nichts an und der Vermischungsschutz waere wirkungslos.
    return Object.assign(
      candidate.week_definition ? { week_definition: String(candidate.week_definition) } : {},
      { period_from: String(candidate.period_from), period_to: String(candidate.period_to), slices });
  }
  if (!candidate || !Array.isArray(candidate.rows) || !candidate.rows.length
      || !candidate.week_from || !candidate.week_to) return null;
  const coverage = candidate.coverage && typeof candidate.coverage === 'object'
    ? allowlisted(candidate.coverage, COVERAGE_FIELDS)
    : undefined;
  return Object.assign(
    candidate.week_definition ? { week_definition: String(candidate.week_definition) } : {}, {
    week_from: String(candidate.week_from),
    week_to: String(candidate.week_to),
    n_trips: candidate.n_trips == null ? null : Number(candidate.n_trips),
    n_duisburg: candidate.n_duisburg == null ? null : Number(candidate.n_duisburg),
  }, coverage ? { coverage } : {}, {
    rows: candidate.rows.map((row) => allowlisted(row, ROW_FIELDS)),
  });
}

export { ROW_FIELDS, COVERAGE_FIELDS, projectMarketDigestAggregatePayload };
